var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-setting-form',{attrs:{"common-setting-data":_vm.commonSettingData,"page-type":"setup"},on:{"updateEditData":_vm.updateEditData}})}
var staticRenderFns = []

export { render, staticRenderFns }